<template>
  <div class="tw-w-full tw-bg-exam-header tw-px-4 tw-py-3">
    <ul class="tw-flex tw-gap-4 tw-items-start">
      <li
        v-for="[groupName, group] in navItems"
        :key="groupName"
        class="tw-flex tw-flex-col tw-items-center tw-flex-1 tw-z-10"
      >
        <span
          class="tw-text-sm tw-font-bold tw-uppercase tw-mb-1.5 tw-flex tw-items-center tw-gap-1"
          :class="groupTextClass(group)"
        >
          <ModuleTypeIcon :type="groupName" />
          {{ group.name }}
        </span>
        <div class="tw-flex tw-gap-1 tw-w-full tw-mb-1">
          <div
            v-for="module in group.modules"
            :key="'bar-' + module.key"
            class="tw-flex-1 tw-h-1 tw-rounded-sm"
            :class="moduleBarClass(module)"
          />
        </div>
        <div class="tw-flex tw-w-full">
          <div
            v-for="module in group.modules"
            :key="module.key"
            class="tw-flex-1 tw-flex tw-justify-center"
          >
            <span
              class="tw-text-xs tw-font-semibold"
              :class="moduleTextClass(module)"
            >
              {{ module.key || '' }}
            </span>
          </div>
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
import ModuleTypeIcon from './ModuleTypeIcon.vue';

export default {
  name: 'ProgressIndicator',
  components: {
    ModuleTypeIcon,
  },
  methods: {
    groupTextClass(group) {
      if (group.active) return 'tw-text-progress';
      if (group.wasActive) return 'tw-text-progress tw-opacity-40';
      return 'tw-text-nav-inactive';
    },
    moduleTextClass(module) {
      if (module.active) return 'tw-text-progress';
      if (module.wasActive) return 'tw-text-progress tw-opacity-40';
      return 'tw-text-nav-inactive';
    },
    moduleBarClass(module) {
      if (module.active) return 'tw-bg-segment-active';
      if (module.wasActive) return 'tw-bg-segment-active tw-opacity-40';
      return 'tw-bg-segment-inactive';
    },
  },
  computed: {
    navItems() {
      return this.$store.getters['exam/navItems'];
    },
  },
};
</script>
